import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=b3d2284e&scoped=true&lang=html&"
import script from "./Invoices.vue?vue&type=script&lang=js&"
export * from "./Invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d2284e",
  null
  
)

export default component.exports